export default __webpack_public_path__ + "static/media/2.ab81500e.png";